var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.314 0.385286C33.9688 0.0859415 33.5107 -0.0484525 33.0585 0.0157367L10.994 3.16784C10.2175 3.27879 9.64079 3.94379 9.64079 4.72814V11.0323V23.2062C8.70728 22.6624 7.62359 22.3492 6.4675 22.3492C2.97961 22.3492 0.14209 25.1868 0.14209 28.6746C0.14209 32.1624 2.97961 35 6.4675 35C9.95538 35 12.7929 32.1624 12.7929 28.6746V12.3992L31.7054 9.69737V20.0542C30.7719 19.5103 29.6882 19.1972 28.5321 19.1972C25.0442 19.1972 22.2067 22.0347 22.2067 25.5226C22.2067 29.0104 25.0442 31.848 28.5321 31.848C32.02 31.848 34.8575 29.0104 34.8575 25.5226V7.88011V1.57596C34.8574 1.11905 34.6591 0.684631 34.314 0.385286ZM6.46743 31.8478C4.71771 31.8478 3.29413 30.4243 3.29413 28.6745C3.29413 26.9248 4.71771 25.5012 6.46743 25.5012C8.21715 25.5012 9.64073 26.9248 9.64073 28.6745C9.64073 30.4243 8.21715 31.8478 6.46743 31.8478ZM31.7053 6.5132L12.7928 9.21502V6.09498L31.7053 3.39315V6.5132ZM28.532 28.6957C26.7823 28.6957 25.3587 27.2722 25.3587 25.5224C25.3587 23.7727 26.7823 22.3491 28.532 22.3491C30.2818 22.3491 31.7053 23.7727 31.7053 25.5224C31.7053 27.2722 30.2818 28.6957 28.532 28.6957Z",
    fill: "#FAB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.8f24279d701b845ab89a6193e006f606.svg";
export { ForwardRef as ReactComponent };